import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signinUser } from "../../Redux/action/AuthAction";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./adminsignin.scss";
import { SpinLoader } from "../Vendor/ImportCandidates";
import logo from "../../images/ebench_logo.png";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { motion } from "framer-motion";

const AdminSignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const loading = useSelector((state) => state.Auth.loading);
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    userType: "ADMIN",
  });

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { email, password } = credentials;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(signinUser({ ...credentials, zoneId: timeZone }));
  };

  return (
    <>
      <ToastContainer />
      <div className="admin-signin-page">
        {/* ===== Header ===== */}
        <header className="admin-header">
          <Link to="/" className="logo-link">
            <motion.img
              src={logo}
              alt="eBench Logo"
              className="admin-logo"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            />
          </Link>

          <div className="admin-badge">
            <span className="dot"></span>
            <span className="badge-text">Admin Portal</span>
          </div>
        </header>

        {/* ===== Main Content ===== */}
        <main className="admin-signin-main">
          {/* LEFT SIDE - INFO */}
          <motion.section
            className="admin-left"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="admin-left-overlay"></div>
            <div className="admin-left-content">
              <div className="admin-brand">
                {/* <div className="logo-box white-badge">
                  <img src={logo} alt="eBench Logo" />
                </div> */}
                <h1 className="admin-heading">
                  Empowering <span className="accent">Admin Excellence</span>
                </h1>
                <p className="admin-subtext">
                  Streamline, supervise, and scale your recruitment ecosystem.
                  Manage every candidate, client, and vendor — all in one smart
                  platform.
                </p>
              </div>

              {/* ===== FEATURES ===== */}
              <div className="admin-feature-grid">
                <div className="feature-item">
                  <div className="icon-box">📊</div>
                  <div>
                    <h4>Real-time Insights</h4>
                    <p>Get live analytics and actionable hiring data.</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="icon-box">⚙️</div>
                  <div>
                    <h4>Workflow Control</h4>
                    <p>Oversee operations and approvals effortlessly.</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="icon-box">🔒</div>
                  <div>
                    <h4>Secure Access</h4>
                    <p>Enterprise-grade security for your team and data.</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="icon-box">🚀</div>
                  <div>
                    <h4>Optimized Performance</h4>
                    <p>Fast, intuitive, and scalable admin operations.</p>
                  </div>
                </div>
              </div>

              {/* ===== MOTIVATIONAL CTA ===== */}
              <div className="admin-cta">
                <p>
                  <strong>Take control.</strong> Drive decisions with data and
                  empower your team to achieve more with{" "}
                  <span className="accent">eBench.</span>
                </p>
              </div>
            </div>
          </motion.section>

          {/* RIGHT SIDE - FORM */}
          <motion.section
            className="admin-right"
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="form-card">
              <div className="form-header">
                <div className="form-icon">🔑</div>
                <h2>Admin Login</h2>
                <p>Access your secure admin dashboard</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={handleInputChange}
                    onFocus={() => setFocusedField("email")}
                    onBlur={() => setFocusedField(null)}
                    className={focusedField === "email" ? "focused" : ""}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <div className="password-wrapper">
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={handleInputChange}
                      onFocus={() => setFocusedField("password")}
                      onBlur={() => setFocusedField(null)}
                      className={focusedField === "password" ? "focused" : ""}
                      required
                    />
                    <span
                      className="toggle-password"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
                    </span>
                  </div>
                </div>

                <button type="submit" className="signin-btn" disabled={loading}>
                  {loading ? <SpinLoader /> : "Log In"}
                </button>
              </form>

              <div className="forgot">
                <Link to="#">Forgot your password?</Link>
              </div>
            </div>
          </motion.section>
        </main>
      </div>
    </>
  );
};

export default AdminSignIn;
